export type ChapterRowSubtitleResolution =
	| { source: 'subtitle' | 'summary'; text: string }
	| { source: 'fallback' };

/** Keeps the authored-field precedence identical across SSR and SPA. */
export function resolveChapterRowSubtitle(input: {
	subtitle?: unknown;
	summary?: unknown;
}): ChapterRowSubtitleResolution {
	const subtitle = cleanText(input.subtitle);
	if (subtitle) return { source: 'subtitle', text: subtitle };

	const summary = cleanText(input.summary);
	if (summary) return { source: 'summary', text: summary };

	return { source: 'fallback' };
}

function cleanText(value: unknown): string {
	return typeof value === 'string' ? value.trim() : '';
}
